import React, { useRef, useEffect, useCallback, useState} from 'react';
import {WIDTH, HEIGHT, PADDING} from './constants.js';
import {connect} from 'react-redux';

const CanvasRegions = (props) => { 
    let ref = useRef(undefined);
    let ctxt = useRef(undefined);
    useEffect(() => {
        ctxt.current = ref.current.getContext('2d');
        ctxt.current.scale(window.devicePixelRatio, window.devicePixelRatio);
    }, []);

    useEffect(() => {
        window.requestAnimationFrame(draw);
    }, [props.isRegionMode, props.parameterMinMax, props.selected]);

    const draw = useCallback(() => {
        if (!ctxt.current) {
            return;
        }
        let c = ctxt.current;
        c.clearRect(0,0,WIDTH,HEIGHT);
        if (!props.isRegionMode) {
            return;
        }
        let _selected = props.selected.flatMap(
            x => x.isPlaneMacro ? x.parameters : x);
        
        for (let 
             {min, max, originalMin, originalMax, depthParameter} of _selected) {
            c.strokeStyle = "#00a4ff";
            c.fillStyle="#23757b4f";
            c.setLineDash([3]);
            c.lineWidth=1;
            let x = WIDTH * (min - originalMin) / (originalMax - originalMin);
            let y = depthParameter ? HEIGHT* (depthParameter.min - depthParameter.originalMin) / (depthParameter.originalMax - depthParameter.originalMin) : 0;
            let h = depthParameter ? HEIGHT * (depthParameter.max - depthParameter.min) / (depthParameter.originalMax - depthParameter.originalMin) : HEIGHT;
            let w =WIDTH * (max - min) / (originalMax - originalMin);
            c.fillRect(x, y,w, h);
            c.strokeRect(x,y,w,h);
        }
    }, [props.isRegionMode, props.parameterMinMax, props.parameters, props.selected]);
        
    return (
        <canvas
          style={{width: WIDTH, height: HEIGHT}}
          width={window.devicePixelRatio * WIDTH} height={window.devicePixelRatio * HEIGHT} className="canvas-regions" ref={ref}>
        </canvas>);
};

const mapStateToProps = (state, props) => {
  return {
      parameterMinMax: state.effects.parameterMinMax
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CanvasRegions);
